import { SafePromise } from '@benzinga/safe-await';
import { RestfulClient, Session } from '@benzinga/session';
import { VerticalsEnvironment } from './environment';
import { Vertical } from './entities';

export class VerticalsRestful extends RestfulClient {
  constructor(session: Session) {
    super(session.getEnvironment(VerticalsEnvironment).verticals, session);
  }

  getVerticals = async (): SafePromise<Vertical[]> => {
    const url = this.session.getEnvironment(VerticalsEnvironment).verticals;
    return this.get(url, { allowsAnonymousAuth: true, credentials: 'omit' });
  };
}
